/**
 * @generated SignedSource<<7604ac780c8d96764d7838fc785b06aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ShortcutsTab_container$data = {
  readonly canEdit?: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_container">;
  readonly " $fragmentType": "ShortcutsTab_container";
};
export type ShortcutsTab_container$key = {
  readonly " $data"?: ShortcutsTab_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShortcutsTab_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ShortcutsTab_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_container"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "canEdit"
          },
          "action": "THROW",
          "path": "canEdit"
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "68870b0a4c832d2519c1a0a32742229a";

export default node;
